import React, { Component } from 'react';
import PropTypes from 'prop-types';
import updateAppIcon from './update-app.svg';
class UpdateAppDialog extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    dismissLabel: PropTypes.string.isRequired,
  }

  onDismiss = () => {
    const { props } = this;
    // console.log('in onDismiss()');
    // this.dialog.style.animationName = 'slideDialogDown';
    // this.dialog.addEventListener('webkitAnimationEnd', () => {
    // console.log('in in onDismiss()');
      props.onDismiss();
    // });
  }

  render() {
    const { props } = this;

    return (
      <div className="lr-update-app-dialog" ref={(dialog) => { this.dialog = dialog; }}>
        <img src={updateAppIcon} alt="Update app" className="lr-update-app-dialog__icon" />
        <div className="lr-update-app-dialog__title">{props.title}</div>
        <div className="lr-update-app-dialog__message">{props.message}</div>

        <button
          type="button"
          className="lr-update-app-dialog__action-button"
          onClick={this.onDismiss}
        >
          {props.dismissLabel}
        </button>
      </div>
    );
  }
}

export default UpdateAppDialog;
